import styled from 'styled-components';
import topview from '../assets/topview.png';

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  background-color: #2563eb;
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 25px;
`;

export const CarIcon = styled.div`
  background: #ffffff;
  width: 60px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #2563eb;
`;

export const CarNumber = styled.div`
  margin-left: 15px;
  color: white;
  font-weight: 700;
  font-size: 18px;
  user-select: none;
`;

export const CarTopView = styled.div`
  position: relative;
  width: 100%;
  max-width: 280px;
  height: 340px;
  margin: 0 auto 20px;
  &:before {
    content: '';
    position: absolute;
    transform: rotate(270deg);
    width: 100%;
    height: 100%;
    background-image: url(${topview});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;

export const TireMarker = styled.div`
  position: absolute;
  width: 36px;
  height: 64px;
  background-color: #2563eb;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
  transition: background-color 0.3s, box-shadow 0.3s;

  span {
    display: block;
    color: white;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    margin-top: 22px;
    user-select: none;
  }

  ${props => props.warning && `
    background-color: #ef4444;
    box-shadow: 0 0 10px rgba(239, 68, 68, 0.5);
    animation: pulse 1.5s infinite alternate;
  `}
`;

export const IconHolderWheel = styled.div`
  font-size: 3.5rem;
  margin: 0.8rem;
  position: absolute;
  animation: linear infinite;
  animation-name: run;
  animation-duration: 6s;

  @keyframes run {
    0%   { left: 0; }
    50%  { left: 70%; }
    100% { left: 0; }
  }

  .actual-wheel-icon {
    animation: spin 3s linear infinite;
    animation-direction: alternate-reverse;
    color: #2563eb;
  }
`;

export const IconHolder = styled.div`
  font-size: 3rem;
  margin-top: 0.8rem;
  display: flex;
  justify-content: space-around;
`;

export const CarView = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Tire = styled.div`
  flex: 1 1 45%;
  min-width: 110px;
  background-color: #f0f9ff;
  border: 1.5px solid #bfdbfe;
  border-radius: 10px;
  padding: 12px 14px;
  padding-bottom: 28px;
  position: relative;
  transition: background-color 0.3s, border-color 0.3s;

  ${props => props.warning && `
    background-color: #fff5f5;
    border-color: #fca5a5;
    animation: pulse 0.4s infinite alternate;
  `}
`;

export const TirePosition = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const Pressure = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
`;

export const Temperature = styled.div`
  font-size: 13px;
  margin-top: 2px;
  color: #64748b;
`;

export const LastUpdated = styled.div`
  position: absolute;
  bottom: 8px;
  right: 10px;
  font-size: 10px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
`;

export const SpareTire = styled.div`
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  user-select: none;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  div {
    font-size: 15px;
    font-weight: 700;
    color: #94a3b8;
    margin-top: 4px;
    letter-spacing: 0;
    text-transform: none;
  }
`;
